<!--
 * @Author: cryi.liu
 * @Date: 2020-05-01 15:33:44
 * @LastEditTime: 2020-06-16 14:26:28
 * @Description: 原 PSS 风格侧栏头部
 -->
<template>
  <div class="sider-head" @click="routeToHome"></div>
</template>

<script>
export default {
  name: 'SiderHead',
  methods: {
    routeToHome() {
      window.open('/mvc/page?loc=portal/gate&skipRefer=1', '_self');
    },
  },
};
</script>

<style lang="less" scoped>
.sider-head {
  height: 31px;
  background: url('../../../../assets/image/bg-sider-head.jpg') no-repeat;
  cursor: pointer;
}
</style>
